(function(){
  document.documentElement.classList.add('js-s');
  function reveal(root){
    var els = (root||document).querySelectorAll('.s-rv:not(.is-in)');
    if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-in')}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
    },{rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(e){ io.observe(e); });
  }
  function tabs(root){
    (root||document).querySelectorAll('.s-tabs').forEach(function(list){
      if(list.__s) return; list.__s = true;
      var btns = Array.prototype.slice.call(list.querySelectorAll('.s-tab'));
      function select(b){
        btns.forEach(function(x){
          var on = x === b; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1;
          var p = document.getElementById(x.getAttribute('aria-controls')); if(p) p.hidden = !on;
        });
      }
      btns.forEach(function(b, i){
        b.addEventListener('click', function(){ select(b); });
        b.addEventListener('keydown', function(e){
          var k = e.key, n = null;
          if(k === 'ArrowRight') n = btns[(i+1)%btns.length];
          if(k === 'ArrowLeft') n = btns[(i-1+btns.length)%btns.length];
          if(n){ e.preventDefault(); n.focus(); select(n); }
        });
      });
    });
  }
  function rails(root){
    (root||document).querySelectorAll('[data-s-rail]').forEach(function(r){
      if(r.__s || r.classList.contains('s-rail--grid')) return; r.__s = true;
      var nav = r.nextElementSibling; if(!nav || !nav.classList.contains('s-rail__nav')) return;
      var bar = nav.querySelector('.s-rail__bar span');
      var prev = nav.querySelector('[data-dir="-1"]'), next = nav.querySelector('[data-dir="1"]');
      function upd(){
        var max = r.scrollWidth - r.clientWidth;
        var ratio = r.clientWidth / r.scrollWidth;
        if(bar){ bar.style.width = (ratio*100)+'%'; bar.style.transform = 'translateX(' + (max>0 ? (r.scrollLeft/max)*((1/ratio)-1)*100 : 0) + '%)'; }
        if(prev) prev.disabled = r.scrollLeft <= 2;
        if(next) next.disabled = r.scrollLeft >= max - 2;
        nav.style.display = max > 4 ? '' : 'none';
      }
      nav.querySelectorAll('.s-rail__btn').forEach(function(b){
        b.addEventListener('click', function(){ r.scrollBy({left: (+b.dataset.dir) * r.clientWidth * 0.75, behavior: 'smooth'}); });
      });
      r.addEventListener('scroll', upd, {passive:true}); window.addEventListener('resize', upd); upd();
    });
  }
  function videos(root){
    var vids = (root||document).querySelectorAll('video[data-s-src]');
    if(!vids.length) return;
    if(!('IntersectionObserver' in window)){ vids.forEach(function(v){ v.src = v.dataset.sSrc; }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        var v = en.target;
        if(en.isIntersecting){ if(!v.getAttribute('src')){ v.src = v.dataset.sSrc; } var p = v.play(); if(p && p.catch) p.catch(function(){}); }
        else { v.pause(); }
      });
    },{rootMargin:'200px 0px'});
    vids.forEach(function(v){ io.observe(v); });
  }
  function init(e){ var root = e && e.target && e.target.querySelectorAll ? e.target : document; reveal(root); tabs(root); rails(root); videos(root); }
  if(document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();